export class AnchorType {
	public static NONE: number = 0;
	public static ROOF_HOOK: number = 1;
	public static HANGER_BOLT: number = 2;
}